// extracted by mini-css-extract-plugin
export default {"wrapper":"zN-z","firstToReview":"AN-z","productCards":"BN-z","productCard":"CN-z","stars":"DN-z","hidden":"EN-z"};